import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import FormikFormWrapper from 'libs/formik_fields/FormikFormWrapper';
import { LoadingButton } from '@mui/lab';
import FileField from '../../libs/formik_fields/FileField';

const emptyProfileQuestion = {
    file: null
};

const profileQuestionSchema = yup.object().shape({
    file: yup.mixed().required('Please select file')
});

const PollQuestionImportFileFormContent = (formik) => {
    const { values, isSubmitting, errors } = formik;

    const navigate = useNavigate();

    console.log('errors', errors);

    return (
        <Grid container spacing={0} py={2}>
            <Grid item xs={12} px={1}>
                <FileField name="file" />
            </Grid>

            <Grid item xs={12} px={1}>
                <LoadingButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    disableElevation
                    loading={isSubmitting}
                    loadingPosition="center"
                >
                    Import
                </LoadingButton>
            </Grid>
        </Grid>
    );
};

function CommonPageDataImportFileForm({ handleSubmit, initialValues, disabledFields }) {
    return (
        <FormikFormWrapper
            initialValues={initialValues ?? emptyProfileQuestion}
            onSubmit={handleSubmit}
            validationSchema={profileQuestionSchema}
            FormContent={PollQuestionImportFileFormContent}
            disabledFields={disabledFields}
        />
    );
}

export default CommonPageDataImportFileForm;
